export default __webpack_public_path__ + "static/media/cloud-download.6418c5cc.svg";